import i18n from 'i18next'

export const getValidations = () => {
  const t = i18n.getFixedT(null, 'session')
  return [
    {
      label: t('passwordValidations.min8Characters'),
      check: form => form.password?.match(/^(?=.{8,})|(?=.{6,})(?=.*[A-Z])/)
    },
    {
      label: t('passwordValidations.minOneLetter'),
      check: form => form.password?.match(/^(?=.*[a-zA-Z])/)
    },
    {
      label: t('passwordValidations.minOneNumber'),
      check: form => form.password?.match(/^(?=.*[0-9])/)
    },
    {
      label: t('passwordValidations.passwordsMustMatch'),
      check: form => form.password === form.repeatPassword
    },
    {
      label: t('passwordValidations.recommendationUppercase')
    },
    {
      label: t('passwordValidations.recommendationSpecialChars')
    }
  ]
}

// Keep for backward compatibility
export const PASSWORD_VALIDATIONS = getValidations()
